import { render, staticRenderFns } from "./Jretouches.vue?vue&type=template&id=5367e75b"
import script from "./Jretouches.vue?vue&type=script&lang=js"
export * from "./Jretouches.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports